module.exports = __webpack_public_path__ + "img/xterra-logo.b40792f0.png";